import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " MyDTG, c’est une app web & mobile qui vous permet de gagner en efficacité sur vos prestations de Diagnostic Technique Global et diversifiez votre activité! ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Le DTG est une prestation qui demande au diagnostiqueur immobilier du temps et s'avère souvent très chronophage, une fois l'intervention sur site passée : reprise des éléments notés sur site, tri et attribution des photos, construction et remplissage du rapport sous Word… Le professionnel a de quoi s’y perdre, en plus des autres missions qui lui incombe. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Avec MyDTG, bénéficiez d'un véritable assistant digital qui vous permet de gagner en productivité et de vous concentrer sur des missions à forte valeur ajoutée! ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Grâce à MyDTG, vous avez la possibilité de préparer votre rendez-vous en amont en le documentant. Sur site, vous renseignez directement dans l'app les pathologies observées et y intégrez les photos prises sur place de façon simple. De retour au bureau, il suffit simplement de finaliser les différentes informations récoltées puis de cliquer sur \"Générer le DTG\" : un rapport complet et conforme à la législation en vigueur est alors édité en PDF, aux couleurs du prestataire, directement partageable au commanditaire. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dtg_card_title = _resolveComponent("dtg-card-title")!
  const _component_dtg_card = _resolveComponent("dtg-card")!
  const _component_dtg_layout_about = _resolveComponent("dtg-layout-about")!

  return (_openBlock(), _createBlock(_component_dtg_layout_about, { title: "A propos de..." }, {
    default: _withCtx(() => [
      _createVNode(_component_dtg_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_dtg_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(" MyDTG (version actuelle : " + _toDisplayString(_ctx.version) + ") ", 1)
            ]),
            _: 1
          }),
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}